import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'salesTax',
	standalone: false,
})
export class SalesTaxPipe implements PipeTransform {
	transform(value: number): string {
		if (value) {
			return value + '%';
		}

		return 'No additional Sales Tax Applies';
	}
}
